/* eslint-disable @typescript-eslint/no-explicit-any */
import styles from "../Styles/dashboard.module.css";
import { Vocabulary } from "../Utils/Vocabulary";
import { urlEnum } from "../Utils/UrlEnum";
import MainTable from "../Components/GenericComponents/MainTable";
import { useMediaQuery } from "@mui/material";
import moment from "moment";
import { euFormatForDateTime } from "../Utils/Config";

export default function Guarantees() {
  const phoneStyle = useMediaQuery("(max-width: 800px)");

  /**
   *
   */
  const guaranteeHeader = [
    { label: Vocabulary.orderNumber, name: "orderNumber", options: { sort: false } },
    {
      label: Vocabulary.product,
      name: "product",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return value.name;
        },
      },
    },
    {
      label: Vocabulary.orderDate,
      name: "orderDate",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return moment(value).format(euFormatForDateTime);
        },
      },
    },
    {
      label: Vocabulary.guaranteeExpirationDate,
      name: "guaranteeExpirationDate",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return moment(value).format(euFormatForDateTime);
        },
      },
    },
  ];

  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <MainTable
        urlEnumApi={urlEnum.guarantees}
        header={guaranteeHeader}
        tableTitle={Vocabulary.guaranteesList}
        hideOptionButtons={{
          add: true,
          edit: {
            condition: (item: any) => true,
          },
          delete: {
            condition: (item: any) => true,
          },
        }}
      />
    </div>
  );
}
